










import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/menu/Header.vue';
// import EmployeeInfo from '@/components/employee/EmployeeInfo.vue';

@Component({
  components: {
    Header,
    // EmployeeInfo,
  },
})
export default class Employee extends Vue {}
